import { render, staticRenderFns } from "./CostGroup.vue?vue&type=template&id=c447903c&"
import script from "./CostGroup.vue?vue&type=script&lang=js&"
export * from "./CostGroup.vue?vue&type=script&lang=js&"
import style0 from "./CostGroup.vue?vue&type=style&index=0&id=c447903c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports